/**
 * Mã lỗi ghi sổ
 * NNLINH 12.07.2022
 */
export default {
  //Warning
  Post_Voucher_InGLVoucherList:
    'Chứng từ này đã được lập trong bảng tổng hợp chứng từ cùng loại hoặc bảng kê. Chương trình sẽ tự động loại bỏ chứng từ này nếu thấy không hợp lệ.',
  Post_Voucher_InVoucherSummary:
    'Chứng từ này đã được lập trong bảng tổng hợp chứng từ cùng loại. Chương trình sẽ tự động loại bỏ chứng từ này nếu thấy không hợp lệ.',
  Post_Voucher_InBUVoucherList:
    'Chứng từ này đã lập bảng kê. Chương trình sẽ tự động loại bỏ chứng từ này nếu chứng từ không hợp lệ.',
  Post_ExsistTAPurchaseSaleList:
    'Chương trình đã tự động loại bỏ hạch toán chi tiết có thay đổi thông tin nhóm HHDV ra khỏi bảng kê mua vào/bán ra.',
  UnPost_Warning_OutwardBeUpdated:
    'Chứng từ <span class="color-blue">{0}</span> đã được chọn để lập các chứng từ <span class="color-blue">{1}</span>. Bạn phải bỏ ghi chứng từ xuất trước khi bỏ ghi chứng từ này.',
  UnPost_Warning_OutwardBeUpdated_Export:
  'Chứng từ {0} đã được chọn để lập các chứng từ {1}. Bạn phải bỏ ghi chứng từ xuất trước khi bỏ ghi chứng từ này.',
  // Error
  Post_ValidateVerifyAccount: 'Định khoản không hợp lệ. Ghi sổ không thành công.',
  Post_NotZeroAmount: 'Giá trị hạch toán phải khác 0. Ghi sổ không thành công.',
  Post_VoucherInvalid: 'Đã xảy ra lỗi ghi sổ không thành công',
  Post_ValidAccDetailBy_AccountingObject: 'Đối tượng',
  Post_ValidAccDetailBy_Activity: 'Hoạt động',
  Post_ValidAccDetailBy_Chapter: 'Chương',
  Post_ValidAccDetailBy_BudgetItem: 'Mục',
  Post_ValidAccDetailBy_BudgetSubItem: 'Tiểu mục',
  Post_ValidAccDetailBy_BudgetKindItem: 'Loại',
  Post_ValidAccDetailBy_BudgetSubKindItem: 'Khoản',
  Post_ValidAccDetailBy_BudgetSource: 'Nguồn',
  Post_ValidAccDetailBy_Fund: 'Loại quỹ',
  Post_ValidAccDetailBy_Method: 'Cấp phát',
  Post_ValidAccDetailBy_Project: 'CTMT',
  Post_ValidAccDetailBy_Task: 'Nhiệm vụ',
  Post_ValidAccDetailBy_BankAccount: 'Tài khoản NH,KB',
  Post_ValidAccDetailBy_Contract: 'Hợp đồng',
  Post_ValidConfrontingRefIDForRealName:
    '<div class="content-error">Vật tư <span class="color-green">{0}-{1}</span> chưa xác định đích danh chứng từ nhập. Ghi sổ không thành công.</div>',
  Post_ValidConfrontingRefIDForRealName_Export:
  'Vật tư {0}-{1} chưa xác định đích danh chứng từ nhập. Ghi sổ không thành công.',
  Post_ValidateOutwardQuantityRealName:
    '<div class="content-error">Không thể xuất Vật tư <span class="color-green">{0}-{1}</span> quá số lượng tồn của chứng từ <span class="color-green">{2}</span>. Số lượng tồn của chứng từ <span class="color-green">{2}</span> là: {3}. Ghi sổ không thành công.</div>',
  Post_ValidateOutwardQuantityRealName_Export:
  'Không thể xuất Vật tư {0}-{1} quá số lượng tồn của chứng từ {2}. Số lượng tồn của chứng từ {2} là: {3}. Ghi sổ không thành công.',
  Post_ValidateOutwardQuantity:
  '<div class="content-error">Không thể xuất Vật tư <span class="color-green">{0}-{1}</span> quá số tồn trong kho <span class="color-green">{2}-{3}</span>. Số tồn tính đến ngày {4}: {5}. Ghi sổ không thành công.</div>',
  Post_ValidateOutwardQuantity_Export:
  'Không thể xuất Vật tư {0}-{1} quá số tồn trong kho {2}-{3}. Số tồn tính đến ngày {4}: {5}. Ghi sổ không thành công.',
  Post_ValidateToolQuantity_Decrement:
    'Không thể ghi giảm CCDC <span class="color-green">{0}-{1}</span> quá số tồn tại phòng ban <span class="color-green">{2}-{3}</span>. Số tồn CCDC tính đến ngày {4}: {5}. Ghi sổ không thành công.',
  Post_ValidateToolQuantity_Tranfer:
    'Không thể điều chuyển CCDC <span class="color-green">{0}-{1}</span> quá số tồn tại phòng ban <span class="color-green">{2}-{3}</span>. Số tồn CCDC tính đến ngày {4}: {5}. Ghi sổ không thành công.',
  Post_ValidateToolAmount_Decrement:
    'Không thể ghi giảm CCDC <span class="color-green">{0}-{1}</span> quá số dư tại phòng ban <span class="color-green">{2}-{3}</span>. Số dư CCDC tính đến ngày {4}: {5}. Ghi sổ không thành công.',
  Post_ValidateToolAmount_Tranfer:
    'Không thể điều chuyển CCDC <span class="color-green">{0}-{1}</span> quá số dư tại phòng ban <span class="color-green">{2}-{3}</span>. Số dư CCDC tính đến ngày {4}: {5}. Ghi sổ không thành công.',
  Post_VoucherInvalid_AccountParent: 'Không hạch toán vào tài khoản tổng hợp.',
  // Yes/no
  UnPost_ErrorUnPostExistInGLVoucherList:
    ' Chứng từ {1} đã được lập Bảng tổng hợp chứng từ cùng loại {0}/Chứng từ ghi sổ {0}. Để bỏ ghi sổ {0}, chương trình sẽ loại bỏ {1} khỏi Chứng từ ghi sổ/Bảng tổng hợp chứng từ cùng loại. Bạn có muốn bỏ ghi không?',
  Post_QuestionClosingDebit: `Số dư của tài khoản <span class="color-green"><{0}></span> đến ngày {1} chỉ còn {2}. Bạn có muốn ghi sổ (chấp nhận xuất quỹ tiền âm) không?`,
  Post_QuestionPurchasePurpose:
    'Cần nhập thông tin "Nhóm HHDV" để lên Bảng kê hóa đơn, chứng từ hàng hóa, dịch vụ mua vào. Bạn có muốn ghi sổ không?',
  Post_Warning_OutwardBeUpdated:
    'Việc ghi sổ này sẽ dẫn đến các chứng từ <span class="color-blue">{0}</span> cũng sẽ được ghi sổ theo, bạn có tiếp tục không?',

  //Error code
  UnPost_ErrorExistInBUVoucherList_Code: 'UnPost_ErrorExistInBUVoucherList',
  UnPost_ErrorUnPostExistInGLVoucherList_Code: 'UnPost_ErrorUnPostExistInGLVoucherList',
  UnPost_Warning_OutwardBeUpdated_Code: 'UnPost_Warning_OutwardBeUpdated',

  //Title
  UnPost_ErrorExistInBUVoucherList_Title: 'Không thể bỏ ghi chứng từ',
  UnPost_Warning_OutwardBeUpdated_Title: 'Bỏ ghi sổ không thành công',
  //Button
  UnPost_ErrorExistInBUVoucherList_Button: 'Xem bảng kê',
  UnPost_Warning_OutwardBeUpdated_Button: 'Đồng ý',
  //Message
  UnPost_ErrorExistInBUVoucherList:
    'Cần thực hiện hủy thanh toán trước khi bỏ ghi chứng từ do chứng từ này đã thanh toán trên bảng kê <span class="color-green">{0}</span>.',
  UnPost_ErrorExistInBUVoucherList_Multi:
    'Chứng từ đã được thanh toán trên bảng kê số <span class="color-blue">{0}</span>.',
  UnPost_ErrorExistInBUVoucherList_Multi_Export:
  'Chứng từ đã được thanh toán trên bảng kê số {0}.',
  UnPost_ErrorUnPostExistInGLVoucherList_All:
    'Chứng từ <span class="color-blue">{1}</span> đã được lập Bảng tổng hợp chứng từ cùng loại <span class="color-blue">{0}</span> và Chứng từ ghi sổ <span class="color-blue">{2}</span>. Để bỏ ghi sổ <span class="color-blue">{1}</span>, chương trình sẽ loại bỏ <span class="color-blue">{1}</span> khỏi Chứng từ ghi sổ và Bảng tổng hợp chứng từ cùng loại. Bạn có muốn bỏ ghi không?',
  UnPost_ErrorUnPostBatchExistInGLVoucherList_All:
    'Chứng từ <span class="color-blue">{0}</span> đã được lập Bảng tổng hợp chứng từ cùng loại và Chứng từ ghi sổ. Để bỏ ghi sổ các chứng từ này, chương trình sẽ loại bỏ các chứng từ trên khỏi Chứng từ ghi sổ và Bảng tổng hợp chứng từ cùng loại. Bạn có muốn bỏ ghi không?',
    UnPost_ErrorUnPostExistInGLVoucherList_Summary:
    'Chứng từ <span class="color-blue">{1}</span> đã được lập Bảng tổng hợp chứng từ cùng loại <span class="color-blue">{0}</span>. Để bỏ ghi sổ <span class="color-blue">{1}</span>, chương trình sẽ loại bỏ <span class="color-blue">{1}</span> khỏi Bảng tổng hợp chứng từ cùng loại. Bạn có muốn bỏ ghi không?',
    UnPost_ErrorUnPostBatchExistInGLVoucherList_Summary:
    'Chứng từ <span class="color-blue">{0}</span> đã được lập Bảng tổng hợp chứng từ cùng loại. Để bỏ ghi sổ các chứng từ này, chương trình sẽ loại bỏ các chứng từ trên khỏi khỏi Bảng tổng hợp chứng từ cùng loại. Bạn có muốn bỏ ghi không?',
    UnPost_ErrorUnPostExistInGLVoucherList_Voucher:
    'Chứng từ <span class="color-blue">{1}</span> đã được lập Chứng từ ghi sổ <span class="color-blue">{0}</span>. Để bỏ ghi sổ <span class="color-blue">{1}</span>, chương trình sẽ loại bỏ <span class="color-blue">{1}</span> khỏi Chứng từ ghi sổ. Bạn có muốn bỏ ghi không?',
  UnPost_ErrorUnPostBatchExistInGLVoucherList_Voucher:
  'Chứng từ <span class="color-blue">{0}</span> đã được lập Chứng từ ghi sổ. Để bỏ ghi sổ các chứng từ này, chương trình sẽ loại bỏ các chứng từ trên khỏi Chứng từ ghi sổ. Bạn có muốn bỏ ghi không?',

  // Message cho xóa nhiều và bỏ ghi chứng từ liên quan
  DeleteUnPost_ErrorUnPostExistInGLVoucherList_Voucher: 'Chứng từ đã được lập Chứng từ ghi sổ {0}.',
  DeleteUnPost_ErrorUnPostExistInGLVoucherList_Summary: 'Chứng từ đã được lập Bảng tổng hợp chứng từ cùng loại {0}.',
  DeleteUnPost_ErrorUnPostExistInGLVoucherList_All:
    'Chứng từ {1} đã được lập Bảng tổng hợp chứng từ cùng loại {0} và Chứng từ ghi sổ {2}.',

  // Mã lỗi chứng từ
  GENERATE_DATA: 'GENERATE_DATA',
  GENERATE_DATAS: 'GENERATE_DATAS',
  VALIDATE: 'VALIDATE',

  // Mã code lỗi
  Delete_ErrorIsPostedVoucher: 'Delete_ErrorIsPostedVoucher',
  Delete_ErrorRelationVoucher: 'Delete_ErrorRelationVoucher',
  Delete_ErrorRelationVouchers: 'Delete_ErrorRelationVouchers',
  Delete_ErrorRelationVoucherSummary: 'Delete_ErrorRelationVoucherSummary',
  Delete_ErrorIsPaymentVoucher: 'Delete_ErrorIsPaymentVoucher',
  Delete_ErrorIsPostedInvoice: 'Delete_ErrorIsPostedInvoice',
  Delete_ErrorReferenceInvoice: 'Delete_ErrorReferenceInvoice',
  Delete_ErrorReferenceReceipt: 'Delete_ErrorReferenceReceipt',
  Delete_ErrorReferenceTicket: 'Delete_ErrorReferenceTicket',
  Delete_ErrorInvoiceReferenceVoucher: 'Delete_ErrorInvoiceReferenceVoucher',
  Delete_ErrorReferenceSalary: 'Delete_ErrorReferenceSalary',
  Delete_ErrorTACircularVATAdditional: 'Delete_ErrorTACircularVATAdditional',
  Delete_ErrorTACircularVATAdditionalOther: 'Delete_ErrorTACircularVATAdditionalOther',

  // Message lỗi tương ứng với mã code

  Message_Delete_ErrorIsPostedVoucher: 'Chứng từ này đã được ghi sổ. Vui lòng kiểm tra lại.',
  Message_Delete_ErrorIsPaymentVoucher: 'Bảng kê <span class="color-blue">{0}</span> đã được thanh toán.',
  Message_Delete_ErrorInvoiceReferenceVoucher:
    '<div>Hóa đơn <span class="color-blue">{0}</span> đã được lập kèm chứng từ bán hàng <span class="color-blue">{1}</span>.</div> <div>Bạn cần kiểm tra lại chứng từ bán hàng.</div>',
  Message_Delete_ErrorIsPostedInvoice:
    '<div>Hóa đơn <span class="color-blue">{0}</span> - <span class="color-blue">{1}</span> - <span class="color-blue">{2}</span> đã phát hành hóa đơn điện tử.</div> <div>Bạn không được phép xóa.</div>',
  Message_Delete_ErrorReferenceSalary: 'Đã sinh chứng từ liên quan. Vui lòng kiểm tra lại.',
  Message_Delete_ErrorTACircularVATAdditional: 'Đã tồn tại tờ khai bổ sung. Vui lòng kiểm tra lại.',
  Message_Delete_ErrorTACircularVATAdditionalOther: 'Đã tồn tại tờ khai bổ sung lần {0}. Vui lòng kiểm tra lại.',
  Message_Post_ValidFixedAssetIncrement:
    'Tài sản <span class="color-green">{0}</span> đã được ghi tăng. Vui lòng kiểm tra lại',

  Message_Post_ValidFixedAssetDecrement:
    'Tài sản <span class="color-green">{0}</span> đã được ghi giảm. Vui lòng kiểm tra lại',

  // Message_Delete_ErrorRelationVoucher: 'Chứng từ này đã được ghi sổ. Vui lòng kiểm tra lại.',

  // Mã lỗi ghi sổ VTHH
  Post_ValidConfrontingRefIDForRealNameCode: 'Post_ValidConfrontingRefIDForRealName',
  Post_ValidateOutwardQuantityRealNameCode: 'Post_ValidateOutwardQuantityRealName',
  Post_ValidateOutwardQuantityCode: 'Post_ValidateOutwardQuantity',

  Post_ValidFixedAssetIncrement: 'Post_ValidFixedAssetIncrement',
  Post_ValidFixedAssetDecrement: 'Post_ValidFixedAssetDecrement',

  Post_ValidQuantityToolCode: 'Post_ValidQuantityTool',
  Post_ValidAmountToolCode: 'Post_ValidAmountTool',
  Post_ValidAmountEstimate: 'Post_ValidAmountEstimate',
};
